import React from 'react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'white';
  text?: string;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'md', 
  color = 'primary', 
  text = 'Loading...',
  fullScreen = false 
}) => {
  const sizeClasses = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border-lg'
  };

  const colorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    white: 'text-white'
  };

  const spinnerSize = sizeClasses[size];
  const spinnerColor = colorClasses[color];

  const content = (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div className={`spinner-border ${spinnerSize} ${spinnerColor} mb-3`} role="status">
        <span className="visually-hidden">{text}</span>
      </div>
      {text && (
        <div className={`${spinnerColor} fw-medium`}>
          {text}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-light bg-opacity-75" style={{ zIndex: 9999 }}>
        {content}
      </div>
    );
  }

  return content;
};

export default Loader;
